import * as React from "react";
const SvgCheckBoxOutlineBlank = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 5v14H5V5h14Zm2-2H3v18h18V3Z",
  fill: "currentColor"
}));
export default SvgCheckBoxOutlineBlank;